import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageSpinner from 'components/PageSpinner';
import { Card, Button } from 'reactstrap';
import PaginationContainer from '../paginationContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { UsersGroupsAction } from 'redux/actions';
import PopupWindow from 'components/ModalPopup';
import AddGroupForm from './add';
import { DateFormat, checkPermissions } from 'hooks';
import { MdModeEdit, MdDelete } from 'react-icons/md';
const UsersGroups = (props) => {
    const [open, setOpen] = React.useState(false);

    const [groupId, setGroupId] = React.useState(null);
    const [groupName, setGroupName] = React.useState(null);
    const [isDelete, setIsDelete] = React.useState(false);

    const fetchList = () => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        props.getUsersGroups(filters);
    }
    React.useEffect(() => {
        fetchList();
    }, [props.pagination, props.order]);

    React.useEffect(() => {
        props.getTotalCount((props.groupsList && props.groupsList.totalRecord ? props.groupsList.totalRecord : 0));
    }, [props.groupsList])

    const columns = () => {
        let columnsList = [
            {
                name: "id",
                label: "S.No.",
            },
            {
                name: "name",
                label: "Group Name",
            },
            {
                name: "created_at",
                label: "Created At",
            },
            {
                name: "updated_at",
                label: "Updated At",
            },
            {
                name: "action",
                label: "Action",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    setCellProps: () => ({
                        style: (column.name === 'action') ? { width: "10%", paddingLeft: "5px" } : { width: 'auto' }
                    }),
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (column.name === 'created_at' || column.name === 'updated_at') ? DateFormat(value) :
                            (column.name === 'action') ? <div>
                                {checkPermissions(props.loginData, 'edit_group') ?
                                    <MdModeEdit onClick={() => handleEdit(tableMeta.rowData)} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                    : <MdModeEdit className={'disabled'} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                }
                                {checkPermissions(props.loginData, 'delete_group') ?
                                    <MdDelete onClick={() => handleDelete(tableMeta.rowData)} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#fc5c7d', marginLeft: 10 }} />
                                    : <MdDelete className={'disabled'} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#fc5c7d', marginLeft: 10 }} />
                                }
                            </div>
                                : value
                    },
                    display: (column.name === 'id') ? false : true,

                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                }
            }
        })
    }

    React.useEffect(() => {
        fetchList();
        setOpen(false);
        setGroupId(null);
        setGroupName(null);
        setIsDelete(false);
        
    }, [props.groupAdded])

    const handlePopup = (status) => {
        setOpen(status);
        if (!status) {
            setGroupId(null);
            setGroupName(null);
            setIsDelete(false);
        }
    }

    const handleEdit = (rowData) => {
        setGroupId(rowData[0]);
        setGroupName(rowData[1]);
        setOpen(true);
    }

    const handleDelete = (rowData) => {
        setIsDelete(true);
        setGroupId(rowData[0]);
        setOpen(true);
    }
    return (
        <div>
            {(checkPermissions(props.loginData, 'add_group') || checkPermissions(props.loginData, 'edit_group') || checkPermissions(props.loginData, 'delete_group')) &&
                <PopupWindow 
                hideButton={!checkPermissions(props.loginData, 'add_group')} 
                handlePopup={handlePopup} 
                openWindow={open} 
                title={(isDelete && groupId) ? 'Delete Group' : (groupId) ? 'Edit Group' : 'Add New Group'} 
                btnClass={(isDelete && groupId) ? 'delete-group' : (groupId) ? 'edit-group' : 'add-new-group'}
                launchButtonText={'Add New Group'}  buttonStyle={{ display: 'block', marginLeft: 'auto', marginBottom: '10px' }}>
                    {isDelete ?
                        <div>
                            <div>
                                Are you sure? Do you want to delete this group?
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button
                                    style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                    size="sm"
                                    onClick={() => {
                                        props.createNewGroup({ id: groupId, isDelete: isDelete });
                                    }}
                                    block >
                                    Yes
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                    size="sm"
                                    onClick={() => setOpen(false)}
                                    block >
                                    No
                                </Button>
                            </div>
                        </div>
                        : <AddGroupForm groupId={groupId} groupName={groupName} />
                    }
                </PopupWindow>
            }
            <Card className="mb-3">
                {props.isLoading ? <PageSpinner />
                    : <DataTables data={(props.groupsList && props.groupsList.groups) ? props.groupsList.groups : []} columns={columns()} options={props.options} />
                }</Card>
        </div>
    );
}
const mapStateToProps = (state) => ({
    groupAdded: (state.groups && state.groups.groupAdded) ? state.groups.groupAdded : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    groupsList: (state.groups && state.groups.groupsList) ? state.groups.groupsList : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getUsersGroups: (payload) => dispatch(UsersGroupsAction.getUsersGroups(payload)),
    createNewGroup: (payload) => dispatch(UsersGroupsAction.addUserGroup(payload))
});
AddGroupForm.propTypes = {
    getUsersGroups: PropTypes.func,
    isLoading: PropTypes.bool,
    groupAdded: PropTypes.object,
    pagination: PropTypes.object,
    order: PropTypes.object,
    getTotalCount: PropTypes.func,
    loginData: PropTypes.object

}
export default PaginationContainer(connect(mapStateToProps, mapDispatchToProps)(UsersGroups), { defaultOrderBy: 'id' });